import React, { useState,useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";

const Header = () =>{
  
  const [menuActive, setMenuActive] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");
      let scrollPosition = window.scrollY;

      sections.forEach((section) => {
        const offsetTop = section.offsetTop - 150;
        const sectionHeight = section.offsetHeight;
        const id = section.getAttribute("id");

        if (scrollPosition >= offsetTop && scrollPosition < offsetTop + sectionHeight) {
          setActiveSection(id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  
  return (
    <header className="header">
      <NavLink className="logo" to="/">
        MOHAMED NABEEL
      </NavLink>

      <FontAwesomeIcon
        icon={faBars}
        id="menu-icon"
        className={menuActive ? "bx-x" : ""}
        onClick={() => setMenuActive(!menuActive)}
      />

      <nav className={`navbar ${menuActive ? "active" : ""}`}>
        <NavLink to="/" className={activeSection === "home" ? "active" : ""}>
          Home
        </NavLink>
        <NavLink to="/About" className={activeSection === "about" ? "active" : ""}>
          About
        </NavLink>
        <NavLink to="/Education" className={activeSection === "education" ? "active" : ""}>
          Education
        </NavLink>
        <NavLink to="/Skill" className={activeSection === "Skill" ? "active" : ""}>
          Skills
        </NavLink>
        <NavLink to="/Projects" className={activeSection === "projects" ? "active" : ""}>
          Projects
        </NavLink>
        <NavLink to="/Contact" className={activeSection === "contact" ? "active" : ""}>
          Contact
        </NavLink>
      </nav>
    </header>
  );
};

export default Header;